import React from 'react';
import _ from 'lodash';
import { inject, observer } from "mobx-react";
import moment from "moment";
import { AxlButton, AxlPopConfirm } from 'axl-reactjs-ui';
import Button from "../../components/JMuiButton";

// Utils
import { SHIPMENT_SERVICE_LEVEL } from '../../constants/status';

// Components
import SingleOrderStepOne from './Components/SingleOrderStepOne';
import SingleOrderStepTwo from './Components/SingleOrderStepTwo';
import SingleOrderStepThree from './Components/SingleOrderStepThree';
import SingleOrderStepFour from './Components/SingleOrderStepFour';
import SingleOrderReview from './Components/SingleOrderReview';
import SingleOrderSubmitted from './Components/SingleOrderSubmitted';

// styles
import styles, * as E from './styles';
import { validateField } from "../../validations/Rules";

@inject("shipmentStore", "userStore")
@observer
class SingleOrderShipmentContainer extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      step: 1,
      successStep: 0,
      shipment: {
        sms_enabled: true,
      },
      parcels: [],
      formErrors: {},
      formWarnings: {},
      responseError: {},
      validates: {
        "customer.name": ["required"],
        "customer.phone_number": ["phone_number"],
        "customer.email": ["email"],
        "pickup_address": ["required"],
        "pickup_address.street": ["required"],
        "pickup_address.city": ["required"],
        "pickup_address.state": ["required"],
        "pickup_address.zipcode": ["required", "zipcode"],
        "pickup_earliest_ts": [],
        "pickup_latest_ts": [],
        "pickup_date_ts": [],
        "pickup_earliest_time": [],
        "pickup_latest_time": [],
        "dropoff_address.street": ["required"],
        "dropoff_address.city": ["required"],
        "dropoff_address.state": ["required"],
        "dropoff_address.zipcode": ["required", "zipcode"],
        "dropoff_earliest_ts": ["required"],
        "dropoff_earliest_time": ["required"],
        "dropoff_latest_ts": ["required"],
        "dropoff_latest_time": ["required"],
        "dropoff_date_ts": ["required"],
        "delivery_window": ["required"],
        "service_level": ["required"],
        "type": ["required"]
      },
      parcel_types: [],
      predefined_parcel_types: [],
      shipment_tags: [],
      delivery_windows: [],
      delivery_window_shifts: [],
      selected_shift: 0,
      selected_group: 0,
      week_delivery_windows: {},
      disable_custom_window: false,
      creatingShipment: false,
      activeShipment: null,
      pickup_location: {lat: 0, lng: 0},
      dropoff_location: {lat: 0, lng: 0},
      cutoff_time: {
        pickup: {
          earliest: 0,
          latest: 0,
        },
        dropoff: {
          earliest: 0,
          latest: 0,
        },
      },
    };
  }

  componentDidMount() {
    const {shipmentStore, userStore} = this.props;
    shipmentStore.getWarehouses();
    shipmentStore.getClientSettings(this.initFormState);
    userStore.getClientProfiles();
  }

  componentWillUnmount() {
    // Reset states
    this.resetState();
  }

  resetState = () => {
    // Reset states
    this.setState({
      step: 1,
      successStep: 0,
      shipment: {
        sms_enabled: true,
      },
      formErrors: {},
      formWarnings: {},
      parcels: [],
      responseError: {}
    });
    this.props.shipmentStore.preFilled = false;
    this.props.shipmentStore.selectWarehouse(-1);
  };

  initFormState = (data) => {
    const parcel_types = [];
    const predefined_types = [];
    const delivery_windows = [];
    let week_delivery_windows = {};
    let delivery_window_shifts = [];
    let shipmentTags = data.shipment_tags || [];
    const cutoff_time = {
      pickup: {
        earliest: 0,
        latest: 0,
      },
      dropoff: {
        earliest: 0,
        latest: 0,
      },
    };
    let disable_custom_window = false;
    // let pickup_earliest_time = '';
    // let pickup_latest_time = '';

    if (data.parcel_types && data.parcel_types.length > 0) {
      data.parcel_types.map(type => parcel_types.push({label: _.capitalize(type), value: type, predefined: false}))
    }

    if (data.client_settings && data.client_settings.order_settings) {
      const orderSettings = data.client_settings.order_settings;

      // set general delivery windows
      if (orderSettings.delivery_windows) {
        delivery_windows.push(...orderSettings.delivery_windows);
      }

      // set delivery windows for each day in week
      if (orderSettings.week_delivery_windows) {
        week_delivery_windows = {...orderSettings.week_delivery_windows};
      }

      // set cutoff time if present
      if (orderSettings.pickup_earliest_cutoff) {
        cutoff_time.pickup.earliest = orderSettings.pickup_earliest_cutoff;
      }
      if (orderSettings.pickup_latest_cutoff) {
        cutoff_time.pickup.latest = orderSettings.pickup_latest_cutoff;
      }
      if (orderSettings.dropoff_earliest_cutoff) {
        cutoff_time.dropoff.earliest = orderSettings.dropoff_earliest_cutoff;
      }
      if (orderSettings.dropoff_latest_cutoff) {
        cutoff_time.dropoff.latest = orderSettings.dropoff_latest_cutoff;
      }

      // disable custom delivery windows if set
      if (orderSettings.disable_custom_window === 'true') {
        disable_custom_window = true;
      }

      // override tags
      if (orderSettings.shipment_tags) {
        shipmentTags = orderSettings.shipment_tags;
      }

      // predefined parcel type, add along with general types
      if (orderSettings.parcel_types && orderSettings.parcel_types.length > 0) {
        orderSettings.parcel_types.map(type => predefined_types.push({...type, predefined: true}));
      }

      // predefined shift
      if (orderSettings.delivery_window_shifts && orderSettings.parcel_types.length > 0) {
        delivery_window_shifts = [...orderSettings.delivery_window_shifts];
      }
    }

    // if (data.last_known_pickup_ts) {
    //   pickup_earliest_time = data.last_known_pickup_ts.pickup_earliest_ts;
    //   pickup_latest_time = data.last_known_pickup_ts.pickup_latest_ts;
    // }

    if (data.client_settings && data.client_settings.label_settings && data.client_settings.label_settings.parcel === 'true') {
      this.state.validates["parcel_id"] = ["required"];
    }

    this.setState({
      shipment_tags: shipmentTags,
      parcel_types: parcel_types,
      predefined_parcel_types: predefined_types,
      delivery_windows,
      delivery_window_shifts,
      week_delivery_windows,
      disable_custom_window: disable_custom_window,
      validates: this.state.validates,
      cutoff_time,
      shipment: {
        ...this.state.shipment,
        sms_enabled: true,
        // pickup_earliest_time,
        // pickup_latest_time,
      }
    })
  };

  handleInputForm = (e) => {
    const shipment = this.state.shipment;
    const name = e.target.name;
    let value = e.target.value;

    if (e.target.type === "checkbox") {
      if (e.target.name === "tags") {
        const tags = this.getFormValue("tags") || [];
        if (e.target.checked) {
          tags.push(value);
        } else {
          const index = tags.indexOf(value);
          if (index > -1) tags.splice(index, 1);
        }
        value = tags;
      } else {
        value = e.target.checked;
      }
    }

    if (name.indexOf('customer') > -1) {
      if (value === '') value = null;
      const customerEmail = this.getFormValue('customer.email');
      const customerPhone = this.getFormValue('customer.phone_number');

      if (!customerEmail) _.set(shipment, 'customer.email', null);
      if (!customerPhone) _.set(shipment, 'customer.phone_number', null);
    }

    if (name.indexOf('value') > -1) {
      if (value === '') value = null;
      this.setFormValue('currency', null);
    }

    _.set(shipment, name, value);
    this.setState({shipment});
    if(name === 'service_level') {
      this.handleDateShippingInformation();
    }
    // validate
    this.handleValidate(name, value);
  };

  handleValidate = (name, value) => {
    if (this.state.validates[name]) {
      let error;
      // Use for...of instead of forEach to properly break on first error
      for (const rule of this.state.validates[name]) {
        error = this.validateRule(rule, name, value);
        if (error) {
          // set error data
          const currentErrors = this.state.formErrors;
          const newErrors = _.merge(currentErrors, {[name]: error[0]});

          this.setState({ formErrors: newErrors });
          break; // Stop checking other rules once we have an error
        }
      }

      if (!error) {
        // if not error reset error for this field
        const currentErrors = this.state.formErrors;
        currentErrors[name] = undefined;

        this.setState({formErrors: currentErrors});
      }
    }
  };

  validateRule = (rule, name, value) => {
    return validateField(rule, name, value);
  };

  getFormValue = (name, defaultValue) => {
    if (!defaultValue) defaultValue = '';
    // get value from shipment
    return _.get(this.state.shipment, name, defaultValue);
  };

  setFormValue = (name, value) => {
    const {shipment} = this.state;
    if (!value) value = null;
    // get value from shipment
    _.set(shipment, name, value);
    this.setState({shipment});
  };

  getFormError = (name) => {
    return this.state.formErrors[name];
  };

  setFormError = (name, value) => {
    const { formErrors } = this.state;

    if(!value) value = null;
    _.set(formErrors, name, value);
    this.setState({formErrors});
  }

  getFormWarning = (name) => {
    return this.state.formWarnings[name];
  };

  searchShipment = (searchKey) => {
    const {shipmentStore} = this.props;
    shipmentStore.search(searchKey, this.replaceInfo, this.resetInfo);
  };

  replaceInfo = (info) => {
    let infoToReplace = {};

    if(this.props.shipmentStore.warehouses.length) {
      infoToReplace = _.pick(info, ["customer", "dropoff_address"]);
    } else {
      infoToReplace = _.pick(info, ["customer", "pickup_address", "dropoff_address","currency","value"]);
      delete infoToReplace.pickup_address.lat;
      delete infoToReplace.pickup_address.lng;
    }

    delete infoToReplace.dropoff_address.lat;
    delete infoToReplace.dropoff_address.lng;

    this.handleValidate('customer.name', infoToReplace.customer.name);
    this.setState({
      shipment: {
        ...this.state.shipment,
        ...infoToReplace,
      }
    });

    if (!infoToReplace.customer.email) infoToReplace.customer.email = null;
    if (!infoToReplace.customer.phone_number) infoToReplace.customer.phone_number = null;
    this.handleValidate('customer.email', infoToReplace.customer.email);
    this.handleValidate('customer.phone_number', infoToReplace.customer.phone_number);
  };

  resetInfo = () => {
    this.setState({
      shipment: {
        ...this.state.shipment,
        customer: {},
        pickup_address: {},
        dropoff_address: {},
      }
    })
  };

  handleSelectWarehouse = (wh) => {
    const {warehouses, selectedWarehouse} = this.props.shipmentStore;
    const whValue = wh.value !== 'new' ? parseInt(wh.value) : 'new';
    const shipment = this.state.shipment;

    if (whValue !== 'new') {
      // auto fill data into pickup
      const origWh = warehouses && warehouses.length > 0 ? warehouses[whValue] : null;

      if (origWh) {
        const address = Object.assign({}, origWh.address);
        if (address['lat']) {
          address['latitude'] = address['lat'];
          delete address['lat'];
        }

        if (address['lng']) {
          address['longitude'] = address['lng'];
          delete address['lng'];
        }

        this.setState({
          shipment: Object.assign({}, shipment, {
            pickup_address: address,
            pickup_note: origWh.notes,
            warehouse_id: origWh.id,
          })
        }, () => {
          // Trigger validation to clear error after address is filled
          this.handleValidate('pickup_address', address);
        })
      }
    } else {
      if (selectedWarehouse !== 'new') { // if changed from different warehouse
        this.setState({
          shipment: Object.assign({}, shipment, {
            pickup_note: '',
            pickup_address: {},
            warehouse_id: undefined,
          })
        }, () => {
          // Trigger validation to show error when address is cleared
          this.handleValidate('pickup_address', {});
        })
      }
    }

    this.props.shipmentStore.selectWarehouse(whValue);
  };

  handleDateTimeInput = (name) => (value) => {
    const shipment = this.state.shipment;

    const date = value ? value.toISOString() : value;
    _.set(shipment, name, date);

    if (name === 'dropoff_date_ts') {
      // reset delivery windows if date change and the weekday delivery windows is set
      _.set(shipment, 'delivery_window', null);
      _.set(shipment, 'dropoff_earliest_time', null);
      _.set(shipment, 'dropoff_latest_time', null);
    }

    this.setState({shipment});

    if (name.indexOf('dropoff') > -1) {
      this.handleCombineDateTime('dropoff');
    } else if (name.indexOf('pickup') > -1) {
      this.handleCombineDateTime('pickup');
    }

    // validate
    this.handleValidate(name, date);
    this.handleDateInputShippingInformation(name);
  };

  handleTimeWindowChange = (value, delivery, group) => () => {
    let windowChanged = {};
    let savedValue = 'new';
    if (value !== 'new' && delivery) {
      savedValue = value + 1;
      windowChanged = {
        dropoff_earliest_time: moment(delivery[0], 'hh:mmA').toISOString(),
        dropoff_latest_time: moment(delivery[1], 'hh:mmA').toISOString(),
      }
    } else {
      // custom time window chose
    }

    this.setFormValue('dropoff_earliest_time', windowChanged.dropoff_earliest_time);
    this.setFormValue('dropoff_latest_time', windowChanged.dropoff_latest_time);
    this.setFormValue('delivery_window', savedValue);
    this.handleValidate('delivery_window', savedValue);
    this.handleCombineDateTime('dropoff');
    this.setState({selected_group: group || 0});
  };

  handleDateShippingInformation = () => {
    const serviceLevel = this.getFormValue('service_level');
    const { ASAP, SAME_DAY, NEXT_DAY } = SHIPMENT_SERVICE_LEVEL;
    const newDateISO = new Date().toISOString();

    if(serviceLevel === ASAP) {
      this.setFormValue('pickup_date_ts', newDateISO);
      this.setFormValue('dropoff_date_ts', newDateISO);
    } else if(serviceLevel === SAME_DAY) {
      this.setFormValue('pickup_date_ts', '');
      this.setFormValue('dropoff_date_ts', '');
    } else if(serviceLevel === NEXT_DAY) {
      this.setFormValue('pickup_date_ts', '');
      this.setFormValue('dropoff_date_ts', '');
    }
  };

  handleDateInputShippingInformation = (name) => {
    if(['pickup_date_ts', 'dropoff_date_ts'].indexOf(name) === -1) {
      return;
    }
    const serviceLevel = this.getFormValue('service_level');
    const { ASAP, SAME_DAY, NEXT_DAY } = SHIPMENT_SERVICE_LEVEL;
    if (serviceLevel === ASAP) {
      // some logic
    } else if (serviceLevel === SAME_DAY) {
      const otherName = name === 'dropoff_date_ts' ? 'pickup_date_ts' : 'dropoff_date_ts';
      this.setFormValue(otherName, this.getFormValue(name));
    } else if (serviceLevel === NEXT_DAY) {
      // some logic
    }
  };

  handleShiftChange = (e) => {
    const shipment = this.state.shipment;
    const shift = e.target.value;

    _.set(shipment, 'delivery_window', null);
    _.set(shipment, 'dropoff_earliest_time', null);
    _.set(shipment, 'dropoff_latest_time', null);

    this.setState({
      selected_shift: shift,
      shipment,
    })
  };

  addParcel = (numberParcel, typeToAdd) => {
    const { parcel_types, predefined_parcel_types } = this.state;
    const parcelTypesList = [...parcel_types, ...predefined_parcel_types];

    const typeIndex = parcelTypesList.findIndex(type => type.label === typeToAdd);
    const parcelType = {...parcelTypesList[typeIndex]};
    parcelType.type = parcelType.value;

    if (typeof parcelType.dimensions === 'undefined') {
      parcelType.dimensions = {};
    }

    if (typeof parcelType.weight === 'undefined') {
      parcelType.weight = {};
    }

    const parcels = _.times(numberParcel, () => ({...parcelType}));

    this.setState({
      parcels: [
        ...this.state.parcels,
        ...parcels,
      ]
    });
  };

  removeParcel = (index) => () => {
    const {parcels} = this.state;
    const filteredParcels = parcels.filter((parcel, idx) => idx !== index);

    this.setState({parcels: filteredParcels});
  };

  handleParcelInput = (index, fname) => (e) => {
    const {parcels} = this.state;
    const name = fname || e.target.name;
    let value = e.value || e.target.value;

    if (e.target && e.target.type === "checkbox") {
      value = e.target.checked;
    }
    _.set(parcels[index], name, value);

    if (name === 'type') {
      _.set(parcels[index], 'label', e.label);
      _.set(parcels[index], 'predefined', e.predefined);
      if (e.predefined) {
        _.set(parcels[index], 'dimensions', e.dimensions);
        _.set(parcels[index], 'weight', e.weight);
      } else {
        _.set(parcels[index], 'dimensions', {length: '', width: '', height: ''});
        _.set(parcels[index], 'weight', {value: ''});
      }
    }

    this.setState({parcels});
    this.handleValidate(name, value);
  };

  handleCombineDateTime = (field) => {
    const {getFormValue, setFormValue} = this;
    const {cutoff_time, formWarnings} = this.state;
    const warnings = {
      [field + '_earliest_time']: '',
      [field + '_latest_time']: '',
      [field + '_date_ts']: '',
    };

    const timeET = getFormValue(field + '_earliest_time');
    const timeLT = getFormValue(field + '_latest_time');
    const timeDT = getFormValue(field + '_date_ts');

    if (!timeDT) {
      setFormValue(field + '_earliest_ts', '');
      setFormValue(field + '_latest_ts', '');
      return false;
    }

    const timeDTs = moment(timeDT).format('MM/DD/YYYY');
    if (timeET) {
      const timeETs = moment(timeET).format('hh:mmA');
      const timeFT = timeDTs + ' ' + timeETs;
      const timeEarliestTS = moment(timeFT, 'MM/DD/YYYY hh:mmA').toISOString();
      setFormValue(field + '_earliest_ts', timeEarliestTS);
      if (cutoff_time[field].earliest) {
        const isWarningEarly = this.compareMinimumCutoffTime(field, 'earliest', cutoff_time[field].earliest);
        if (isWarningEarly) {
          warnings[field + '_earliest_time'] = 'Time is too early!';
          warnings[field + '_date_ts'] = 'Time is too early!';
        }
      }
    } else {
      setFormValue(field + '_earliest_ts', '');
    }

    if (timeLT) {
      const timeLTs = moment(timeLT).format('hh:mmA');
      const timeFT = timeDTs + ' ' + timeLTs;
      const timeLatestTS = moment(timeFT, 'MM/DD/YYYY hh:mmA').toISOString();
      setFormValue(field + '_latest_ts', timeLatestTS);
      if (cutoff_time[field].latest) {
        const isWarningLate = this.compareMinimumCutoffTime(field, 'latest', cutoff_time[field].latest);
        if (isWarningLate) {
          warnings[field + '_latest_time'] = 'Time is too early!';
          warnings[field + '_date_ts'] = 'Time is too early!';
        }
      }
    } else {
      setFormValue(field + '_latest_ts', '');
    }

    this.setState({
      formWarnings: {
        ...formWarnings,
        ...warnings,
      }
    })
  };

  prevStep = () => {
    this.setState({
      step: this.state.step - 1,
      formErrors: {},
    });
  };

  goStep = (st) => {
    const {step, successStep} = this.state;
    if (!st) st = step + 1; // next step clicked

    if (successStep === 5) return ; // all done, no turn back
    if (st > successStep + 2 || (st === successStep + 2 && step < st - 1) || st === step) return; // no jump off or click same step pls!

    if (st <= successStep && st < step && step === successStep + 1) { // go back to edit success step, no need to validate current step
      this.setState({
        step: st,
        formErrors: {},
      });
      return true;
    }

    if (this.validateCurrentStep(st)) {
      this.successGoStep(st);
    }
  };

  successGoStep = (step) => {
    const {successStep} = this.state;
    this.setState({
      step: step,
      successStep: successStep < step - 1 ? step - 1 : successStep,
    })
  };

  validateCurrentStep = (stepToGo) => {
    let valid = false;

    switch (this.state.step) {
      case 1:
        this.handleValidate('customer.name', this.getFormValue('customer.name'));
        //this.handleValidate('customer.email', this.getFormValue('customer.email'));
        //this.handleValidate('customer.phone_number', this.getFormValue('customer.phone_number'));
        // this.state.parcels.map(parcel => this.handleValidate('parcel.type', parcel.type));
        // this.state.parcels.map(parcel => this.handleValidate('parcel_id', parcel.parcel_id));
        break;
      case 2:
        this.handleValidate('pickup_address', this.getFormValue('pickup_address'));
        this.handleValidate('pickup_address.street', this.getFormValue('pickup_address.street'));
        this.handleValidate('pickup_address.city', this.getFormValue('pickup_address.city'));
        this.handleValidate('pickup_address.state', this.getFormValue('pickup_address.state'));
        this.handleValidate('pickup_address.zipcode', this.getFormValue('pickup_address.zipcode'));
        break;
      case 3:
        this.handleValidate('dropoff_address.street', this.getFormValue('dropoff_address.street'));
        this.handleValidate('dropoff_address.city', this.getFormValue('dropoff_address.city'));
        this.handleValidate('dropoff_address.state', this.getFormValue('dropoff_address.state'));
        this.handleValidate('dropoff_address.zipcode', this.getFormValue('dropoff_address.zipcode'));
        break;
      case 4:
        this.handleValidate('service_level', this.getFormValue('service_level'));
        this.handleValidate('pickup_earliest_time', this.getFormValue('pickup_earliest_time'));
        this.handleValidate('pickup_latest_time', this.getFormValue('pickup_latest_time'));
        this.handleValidate('pickup_date_ts', this.getFormValue('pickup_date_ts'));
        this.handleValidate('delivery_window', this.getFormValue('delivery_window'));
        this.handleValidate('dropoff_earliest_time', this.getFormValue('dropoff_earliest_time'));
        this.handleValidate('dropoff_latest_time', this.getFormValue('dropoff_latest_time'));
        this.handleValidate('dropoff_date_ts', this.getFormValue('dropoff_date_ts'));
        break;
      default:
        break;
    }

    if(!Object.values(this.state.formErrors).filter(e => e).length) {
      if (this.state.step === 2) {
        if (this.props.shipmentStore.selectedWarehouse === 'new') {
          this.geocodeAddress(false, (res) => {
            if (res.status === 'GEOCODED') {
              this.setFormValue('pickup_address.latitude', res.pickup_address.lat);
              this.setFormValue('pickup_address.longitude', res.pickup_address.lng);
              this.setState({
                pickup_location: {
                  lat: res.pickup_address.lat,
                  lng: res.pickup_address.lng,
                }
              });

              setTimeout(() => this.successGoStep(stepToGo), 500);
            } else {
              // fail to geocode
              this.setState({
                formErrors: {
                  ...this.state.formErrors,
                  'pickup_address.street': 'Check again',
                  'pickup_address.city': 'Check again',
                  'pickup_address.state': 'Check again',
                  'pickup_address.zipcode': 'Check again',
                }
              });
            }
          });
        } else {
          valid = true;
        }
      } else if (this.state.step === 3) {
        this.geocodeAddress(true, (res) => {
          if (res.status === 'GEOCODED') {
            this.setFormValue('dropoff_address.latitude', res.dropoff_address.lat);
            this.setFormValue('dropoff_address.longitude', res.dropoff_address.lng);
            this.setState({
              dropoff_location: {
                lat: res.dropoff_address.lat,
                lng: res.dropoff_address.lng,
              },
              responseError: {}
            });

            setTimeout(() => this.successGoStep(stepToGo), 500);
          } else {
            // fail to geocode
            this.setState({
              formErrors: {
                ...this.state.formErrors,
                'dropoff_address.street': 'Check again',
                'dropoff_address.city': 'Check again',
                'dropoff_address.state': 'Check again',
                'dropoff_address.zipcode': 'Check again',
              },
              responseError: {
                code: "FAILED",
                msg: res.errors ? res.errors.join(' ') : 'Failed to geocode shipment!',
              }
            });
          }
        });
      } else if (this.state.step === 4) {
        const comparePickupTimeError = this.compareTimeWindowError('pickup_earliest_time', 'pickup_latest_time');
        const compareMinDropoffError = this.compareMinimumCutoffTime('dropoff', 'latest', 60);
        const validPickupAndDropoffTime = this.validatePickupAndDropoff();
        const errorsShow = {};

        if (comparePickupTimeError) {
          errorsShow.pickup_earliest_time = 'Must be earlier than Latest Pick-Up Time';
          errorsShow.pickup_latest_time = 'Must greater than Earliest Pick-Up Time';
        }

        if (compareMinDropoffError) {
          errorsShow.dropoff_date_ts = 'Dropoff time is too early';
          errorsShow.dropoff_earliest_time = 'Dropoff time is too early';
          errorsShow.dropoff_latest_time = 'Dropoff time is too early';
          errorsShow.delivery_window = 'Dropoff time is too early';
        }

        if (!validPickupAndDropoffTime) {
          errorsShow.pickup_latest_time = 'Must be earlier than Dropoff Latest Time and greater than 1h from now';
          errorsShow.pickup_date_ts = 'Must be earlier than Dropoff Latest Time';
          errorsShow.dropoff_latest_time = 'Must greater than Pickup Latest Time';
          errorsShow.dropoff_date_ts = 'Must greater than Pickup Latest Time';
        }

        if (this.getFormValue('delivery_window') === 'new') {
          const compareDropoffTimeError = this.compareTimeWindowError('dropoff_earliest_time', 'dropoff_latest_time');
          if (!compareDropoffTimeError && !comparePickupTimeError && !compareMinDropoffError && validPickupAndDropoffTime) {
            valid = true;
          } else {
            if (compareDropoffTimeError) {
              errorsShow.dropoff_earliest_time = 'Must be earlier than Latest Dropoff Time';
              errorsShow.dropoff_latest_time = 'Must greater than Earliest Dropoff Time';
            }

            this.setState({
              formErrors: {
                ...this.state.formErrors,
                ...errorsShow,
              }
            });
          }
        } else {
          if (!comparePickupTimeError && !compareMinDropoffError && validPickupAndDropoffTime) {
            valid = true;
          } else {
            this.setState({
              formErrors: {
                ...this.state.formErrors,
                ...errorsShow,
              }
            });
          }
        }
      } else {
        valid = true;
      }
    }

    return valid;
  };

  compareTimeWindowError = (earliest, latest) => {
    const early = this.getFormValue(earliest);
    const late = this.getFormValue(latest);
    if (early && late) {
      const earlyTS = moment(early).format('HH:mm');
      const lateTS = moment(late).format('HH:mm');
      if (earlyTS >= lateTS) {
        return true;
      }
    }

    return false;
  };

  compareMinimumCutoffTime = (field, type, minutes) => {
    const dropoffLT = this.getFormValue(field + '_'+ type +'_ts');
    const dropoffLTs = parseInt(moment(dropoffLT).format('x'));
    const minDropoffTS = parseInt(moment().format('x')) + minutes*60*1000;

    return dropoffLTs < minDropoffTS;
  };

  validatePickupAndDropoff = () => {
    const pickup_latest_ts = this.getFormValue('pickup_latest_ts');
    const dropoff_latest_ts = this.getFormValue('dropoff_latest_ts');
    if (pickup_latest_ts) {
      const pickupLTs = parseInt(moment(pickup_latest_ts).format('x'));
      const dropoffLTs = parseInt(moment(dropoff_latest_ts).format('x'));
      const allowedPickupLTs = parseInt(moment().format('x')) + 60*60*1000;

      return pickupLTs <= dropoffLTs && pickupLTs > allowedPickupLTs;
    }

    return true;
  };

  geocodeAddress =  (isDropoff, callback) => {
    const submittedShipment = {...this.state.shipment};

    delete submittedShipment.pickup_earliest_time;
    delete submittedShipment.pickup_latest_time;
    delete submittedShipment.pickup_date_ts;
    delete submittedShipment.dropoff_date_ts;
    delete submittedShipment.dropoff_earliest_time;
    delete submittedShipment.dropoff_latest_time;
    delete submittedShipment.delivery_window;
    if (isDropoff && submittedShipment.dropoff_address) {
      delete submittedShipment.dropoff_address.latitude;
      delete submittedShipment.dropoff_address.longitude;
    }
    if (!isDropoff && submittedShipment.pickup_address) {
      delete submittedShipment.pickup_address.latitude;
      delete submittedShipment.pickup_address.longitude;
    }

    this.props.shipmentStore.geocodeShipment(submittedShipment, isDropoff, callback);
  };

  renderStep = () => {
    const {shipmentStore, userStore} = this.props;
    const {isStoreUser, user} = userStore;
    if (isStoreUser && user) {
      shipmentStore.selectWarehouse(user.externalId);
    }

    let step;
    const childProps = {
      goStep: this.goStep,
      resetState: this.resetState,
      shipment: this.state.shipment,
      shipmentStore: this.props.shipmentStore,
      searchShipment: this.searchShipment,
      parcels: this.state.parcels,
      addParcel: this.addParcel,
      removeParcel: this.removeParcel,
      handleParcelInput: this.handleParcelInput,
      getFormWarning: this.getFormWarning,
      getFormError: this.getFormError,
      setFormError: this.setFormError,
      getFormValue: this.getFormValue,
      setFormValue: this.setFormValue,
      handleInputForm: this.handleInputForm,
      handleDateTimeInput: this.handleDateTimeInput,
      handleSelectWarehouse: this.handleSelectWarehouse,
      handleTimeWindowChange: this.handleTimeWindowChange,
      handleShiftChange: this.handleShiftChange,
      searchingShipment: this.props.shipmentStore.searchingShipment,
      deliveryWindows: this.state.delivery_windows,
      deliveryWindowShifts: this.state.delivery_window_shifts,
      selectedShift: this.state.selected_shift,
      selectedGroup: this.state.selected_group,
      weekDeliveryWindows: this.state.week_delivery_windows,
      disableCustomWindow: this.state.disable_custom_window,
      parcelTypes: this.state.parcel_types,
      predefinedParcelTypes: this.state.predefined_parcel_types,
      shipmentTags: this.state.shipment_tags,
      activeShipment: this.state.activeShipment,
      selectedWarehouse: this.props.shipmentStore.selectedWarehouse,
      isStoreUser,
    };

    switch (this.state.step) {
      case 1:
        step = <SingleOrderStepOne {...childProps} userStore={userStore} />;
        break;
      case 2:
        step = <SingleOrderStepTwo {...childProps} />;
        break;
      case 3:
        step = <SingleOrderStepThree {...childProps} />;
        break;
      case 4:
        step = <SingleOrderStepFour {...childProps} />;
        break;
      case 5:
        step = <SingleOrderReview {...childProps} userStore={userStore} />;
        break;
      case 6:
        step = <SingleOrderSubmitted {...childProps} />;
        break;
      default:
        step = <SingleOrderStepOne {...childProps} userStore={userStore} />;
        break;
    }

    return step;
  };

  createShipment = () => {
    const { shipmentStore } = this.props;
    const that = this;

    // validate all data
    const newProps = {
      pickup_address: {
        latitude: this.state.shipment.pickup_address.lat,
        longitude: this.state.shipment.pickup_address.lng
      },
      dropoff_address: {
        latitude: this.state.shipment.dropoff_address.lat,
        longitude: this.state.shipment.dropoff_address.lng
      }
    };
    let shipment = Object.assign({}, this.state.shipment);
    const whObj = {};
    whObj.address = Object.assign({}, shipment.pickup_address);
    whObj.address.lat = this.state.pickup_location.lat || undefined;
    whObj.address.lng = this.state.pickup_location.lng || undefined;

    // Delete unneeded data
    delete shipment.pickup_earliest_time;
    delete shipment.pickup_latest_time;
    delete shipment.pickup_address.lat;
    delete shipment.pickup_address.lng;
    delete shipment.dropoff_address.lat;
    delete shipment.dropoff_address.lng;
    delete shipment.delivery_window;
    delete shipment.pickup_date_ts;
    delete shipment.dropoff_date_ts;
    delete shipment.dropoff_earliest_time;
    delete shipment.dropoff_latest_time;
    _.merge(shipment, newProps);

    const callback = (response) => {
      this.setState({creatingShipment: true});
      if (response.status === 200) {
        shipmentStore.getShipment(response.data.id, (res) => {
          if(res.status) {
            that.setState({
              step: that.state.step + 1,
              successStep: 5,
              activeShipment: res.data,
              creatingShipment: false,
              responseError: {},
            });
          } else {
            this.setState({
              creatingShipment: false,
              responseError: {
                code: response.status,
                msg: response.data && response.data.errors ? response.data.errors.join(' ') : 'Fail to load submitted shipment!',
              }
            });
          }
        });
      } else {
        // process to display error here
        this.setState({
          creatingShipment: false,
          responseError: {
            code: response.status,
            msg: response.data && response.data.errors ? response.data.errors.join(' ') : 'Fail to submit order!',
          }
        });
      }
    };

    shipment.parcels = this.state.parcels.filter(parcel => !!parcel.type);
    shipment.workload = shipment.parcels.length > 1 ? shipment.parcels.length : 1;

    // If new pickup address is created, we save it for later reuse
    if (this.props.shipmentStore.selectedWarehouse === 'new') {
      shipmentStore.saveWarehouse(whObj);
    }

    if (this.props.match && this.props.match.params && this.props.match.params.id) {
      shipmentStore.updateShipment(this.props.match.params.id, shipment, callback);
    } else {
      shipmentStore.saveShipment(shipment, callback);
    }
  };

  cancelOrder = () => {
    this.setState({
      step: 1,
      shipment: {},
      successStep: 0,
      parcels: [],
      formErrors: {},
      formWarnings: {},
      responseError: {},
      creatingShipment: false,
      activeShipment: null,
      cutoff_time: {
        pickup: {
          earliest: 0,
          latest: 0,
        },
        dropoff: {
          earliest: 0,
          latest: 0,
        },
      },
    });
    this.props.shipmentStore.preFilled = false;
    this.props.shipmentStore.selectWarehouse(-1);
    this.goStep(1);
  };

  render() {
    const { shipmentStore, userStore } = this.props;
    const { activeShipment, responseError } = this.state;
    const { preFilled } = shipmentStore;
    const title = this.state.step < 6 ? `Jitsu Single Order Submission` : `Order ${_.defaultTo(activeShipment && activeShipment.internal_id, '-')} has been submitted!`;
    const subTitle = this.state.step < 6 ? 'Please fill out the information below' : 'Your order has been submitted to Jitsu.';

    return (<E.Container>
      <E.Title>{title}</E.Title>
      <E.SubTitle>{subTitle}</E.SubTitle>
      <E.Process>
        <E.Processer>
          {['Customer & Order Info', 'Pick-Up Info', 'Dropoff Info', 'Shipping Info', 'Review & Submit'].map((value, index) =>
          <E.ProcesserItem key={index}>
            <E.ProcessBar
              className={this.state.step === (index + 1) ? 'active' : this.state.successStep > index ? 'success' : (preFilled && [1, 2].indexOf(index) !== -1) ? 'pre-fill' : ''}
              onClick={() => this.goStep(index + 1)}
            />
            <E.ProcessStatus className={this.state.step === (index + 1) ? 'active' : this.state.successStep > index ? 'success' : ''}>{value}</E.ProcessStatus>
            {(index + 1) !== 5 && <E.ProcessLine className={this.state.successStep >= (index + 1) ? 'success' : ''} />}
          </E.ProcesserItem>)}
        </E.Processer>
      </E.Process>
      { this.renderStep() }
      {!!responseError.code && (
        <div style={styles.error}>
          {`Error ${responseError.code}: ${responseError.msg}`}
        </div>
      )}
      {this.state.step < 5 && (
        <E.Row style={styles.controls}>
          <E.Col style={styles.col_1}>
            {(this.state.step > 1 && this.state.step < 5) &&
            <AxlButton
              compact
              onClick={this.prevStep}
              style={styles.control}
              bg={`blueGray`}
            >
              {`Back`}
            </AxlButton>}
          </E.Col>
          <E.Col style={styles.col_mid}>
            {(this.state.successStep === 4 && this.state.step < 5) &&
            <AxlButton
              compact
              onClick={() => this.goStep(5)}
              style={styles.control}
            >
              {`Review & Submit`}
            </AxlButton>}
          </E.Col>
          <E.Col style={styles.col_2}>
            {this.state.step < 5 &&
              <Button
                variant="contained"
                color="primary"
                onClick={() => this.goStep()}
                loading={this.props.shipmentStore.geocodingShipment}
                size="small"
              >
                {`Next`}
              </Button>}
          </E.Col>
        </E.Row>
      )}
      {this.state.step === 5 && <E.Row>
        {/*<E.Col style={styles.col_1}>
          <AxlButton compact onClick={this.prevStep} style={styles.control} bg={`blueGray`}>{`SAVE`}</AxlButton>
          <AxlButton compact onClick={this.prevStep} style={styles.control} bg={`blueGray`}>{`DOWNLOAD`}</AxlButton>
        </E.Col>*/}
        <E.Col style={styles.col_1}>
          <AxlPopConfirm
            trigger={<Button variant="outlined" color="warning" onClick={this.cancelOrder}>{`CANCEL`}</Button>}
            titleFormat={<div>{`Cancel Order`}</div>}
            textFormat={<div>{`Please confirm you want to cancel submitting new order?`}</div>}
            okText={`OK`}
            onOk={this.cancelOrder}
            cancelText={`Cancel`}
            onCancel={() => null} />
        </E.Col>
        <E.Col style={styles.col_2}>
          <Button variant="contained" color="primary" onClick={this.createShipment} disabled={this.state.creatingShipment} loading={this.state.creatingShipment}>{`CONFIRM`}</Button>
        </E.Col>
      </E.Row>}
    </E.Container>);
  }
}

export default SingleOrderShipmentContainer;